import useTranslation from 'next-translate/useTranslation'
import { twMerge } from 'tailwind-merge'
import { DataSource } from '@unreserved-frontend-v2/api/generated/graphql/types'

export interface TrademarkProps {
  source: DataSource
  className?: string
}

export function Trademark({ source, className = '' }: TrademarkProps) {
  const { t } = useTranslation()
  let key = ''
  switch (source) {
    case DataSource.CreaMls:
      key = 'real-estate:trademark.crea'
      break
    case DataSource.OrebMls:
      key = 'real-estate:trademark.oreb'
      break
    case DataSource.TrrebMls:
      key = 'real-estate:trademark.trreb'
      break
    default:
      key = ''
      break
  }

  return key ? (
    <div data-testid="trademark" className={twMerge('text-shades-350 text-sm leading-[22px]', className)}>
      {t(key)
        .split('\n')
        .map((text, i) => (
          // Make sure to add a bit of height if we don't have any text so that we have some spacing for a blank line.
          <p key={i} className={text ? '' : 'h-1'}>
            {text}
          </p>
        ))}
    </div>
  ) : null
}

export default Trademark
